import {Formik} from "formik";
import CustomTabMenu from "../component/CustomTabMenu";
import {danhSachTabKhoVatTu} from "./Constant";

export const QuanlyCDT: React.FC = () => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {
    }}>
      <div className="bg-white h-100">
        <div className="flex-1 flex flex-column">
          <CustomTabMenu
            childrenTab
            danhsachTabs={danhSachTabKhoVatTu()}
            className="spaces pl-0"
          />
        </div>
      </div>
    </Formik>
  );
};

export default QuanlyCDT;
